export const UPDATE_DELAY_BY_SECOND = process.env.REACT_APP_UPDATE_DELAY_BY_SECOND;
export const UPDATE_DATA_BY_MINUTE = process.env.REACT_APP_UPDATE_DATA_BY_MINUTE;
export const UPDATING_DELAY_BY_SECOND = process.env.REACT_APP_UPDATING_DELAY_BY_SECOND;
export const REACT_APP_PASSWORD = process.env.REACT_APP_PASSWORD
export const REACT_APP_WEBCRM_API = process.env.REACT_APP_WEBCRM_API